import { ReactElement } from 'react';
import { IntegrationsContext } from './Integrations.context';
import useIntegrations from './Integrations.hook';
import { tIntegrationsProviderProps } from './Integrations.types';

export default function IntegrationsProvider(
  props: tIntegrationsProviderProps,
): ReactElement {
  const { children } = props;
  const integrations = useIntegrations();

  return (
    <IntegrationsContext.Provider value={integrations}>
      {children}
    </IntegrationsContext.Provider>
  );
}
